import React from "react";
import ResetPasswordCard from "./components/ResetPasswordCard";

function ResetPasswordMain() {
  return (
    <section className="auth-main-page d-flex align-items-center justify-content-center">
      <ResetPasswordCard />
    </section>
  );
}

export default ResetPasswordMain;
